import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import * as PIXI from "pixi.js";
import { Settings } from "../../../Settings";
import { SpineResource } from "../../../ResourceManager/SpineResource";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { ISkeletonData, Spine } from "../../../PixiSpineRuntime";
import { JackpotProperties } from "../../../JackpotProperties";
import { JackpotLevel } from "../../../api";
import { AwardJPShowElemntPIXAPP, AwardJPShowPIXAPP } from "./AwardJPShowPIXAPP";
import { CreateSpineResources, Scale } from "../../../MyHelpers";
import gsap from "gsap";

export class AwardJPShowNewLookElemntPIXAPP extends AwardJPShowElemntPIXAPP {
protected override elementsLengt : number = 35;
 public override SetSkin(jp: JackpotLevel) {
        this.awardDimmondSpine.forEach(element => {
            let lowerSideTextrues = element.children.filter(elementchild => {
                if (elementchild.name.includes("Gema") || elementchild.name.includes("Gema2") ) return elementchild
                return null;
            });

            lowerSideTextrues.forEach(ele => {
                let color = new PIXI.Color(JackpotProperties[Settings.JackpotDisplayType][jp].color).toRgb();
                (element as Spine).skeleton.findSlot(ele.name).color.set(color.r, color.g, color.b, 1);
            });
        })
    }

    /**
     * Responsive-friendly positioning:
     * - center X deterministically (avoid random drift)
     * - constrain Y + scale to a single screen slice (avoid "too big" multi-screen spill)
     */
    public override CreatePIXIAPP(view: PIXI.Container, boundsWidth: number = Settings.ScreenWidth, boundsHeight: number = Settings.ScreenHeight) {
        this.awardDimmondSpine = [];

        const minScale = 0.35;
        const maxScale = 0.70;

        for (let i = 0; i < this.elementsLengt; i++) {
            const award = CreateSpineResources(this.spinSpineJson);
            award.name = "AwardJPShowElemntPIXAPP";

            award.x = Math.random() * boundsWidth;
            award.y = Math.random() * boundsHeight;

            const scale = parseFloat((minScale + Math.random() * (maxScale - minScale)).toFixed(2));
            award.scale.set(Scale.XY(scale));
            award.pivot.set(award.width / 2, award.height / 2);
            award.rotation = (Math.random() * 30 - 15) * Math.PI / 180;

            view.addChild(award);
            this.awardDimmondSpine.push(award);
            award.state.timeScale = scale;

            award.renderable = false;
            award.visible = false;
        }
    }

    public override StartAnim(boundsHeight: number = Settings.ScreenHeight) {
        this.animating = true;
        gsap.killTweensOf(this.awardDimmondSpine);
        this.awardDimmondSpine.forEach(element => {
            element.visible = true;
            element.renderable = true;
            element.state.setAnimation(0, "animation", true);
            element.state.setAnimation(1, "animationSparks", true);
        });

        gsap.to(this.awardDimmondSpine, {
            duration: 30,
            ease: "none",
            y: "+=" + boundsHeight,
            modifiers: {
                y: function (y) {
                    const nextY = parseFloat(y);
                    return (((nextY % boundsHeight) + boundsHeight) % boundsHeight).toString();
                },
            },
            repeat: -1,
        });
    }

    // protected override ScaleRandom(){        
    //     return  parseFloat((0.5 + Math.random()).toFixed(2));
    // }
    
}


export class AwardJPShowNewLookPIXAPP extends AwardJPShowPIXAPP{
    public override PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        let bonusResorucesSpine : string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine`;
		//preload spine
		resourceManager.AddGlobal(new SpineResource(`${bonusResorucesSpine}/AwardJPSPine/AwardJPSpineNewLook.json`, ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineSpine`)));
    }

     public override ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
            let skeletonData = resourceManager.Get<SpineResource>(ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineSpine`)).skeletonData;
            this.awardElements = new AwardJPShowNewLookElemntPIXAPP(skeletonData);
        }
    

    protected override awardElements : AwardJPShowNewLookElemntPIXAPP = null;
}